import { PencilIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const editableZoneClassName =
  'border border-dashed border-muted-foreground/50 rounded-sm p-2'

export interface EditableZoneProps {
  children: ReactNode
  onClick?: () => void
  className?: string
  ariaLabel?: string
  showIcon?: boolean
}

export const EditableZone = ({
  children,
  onClick,
  className,
  ariaLabel,
  showIcon = true,
}: EditableZoneProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        'group relative w-full rounded-sm text-left transition-colors',
        editableZoneClassName,
        'hover:border-link',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
    >
      {children}
      {showIcon && (
        <PencilIcon
          className="absolute top-0 right-0 size-3.5 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100"
          aria-hidden
        />
      )}
    </button>
  )
}
